const PageNotFound = () => {
  return (
    <div style={{ margin: "1rem", display: "grid", placeItems: "center" }}>
      Page Not Found
    </div>
  );
};

export default PageNotFound;
